import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { showToast } from 'src/utils/showToaster';
import BookForm from '../Layouts/BooksForm';
import { BooksFormValues } from 'src/models/Books.model';
import { useAddBookMutation } from 'src/services/BookService';

type Props = {
    onClose: () => void;
};

const AddBookWrapper = ({ onClose }: Props) => {
    // Form Initial Values
    const initialValues: BooksFormValues = {
        bookName: '',
    };

    // Validation Schema
    const validationSchema = object().shape({
        bookName: string().required('Please enter book name'),
    });


    const [addBook] = useAddBookMutation()

    // Handle Submit
    const handleSubmit = (
        values: BooksFormValues,
        { setSubmitting, resetForm }: FormikHelpers<BooksFormValues>
    ) => {
        addBook(values).then((res: any) => {
            if (res?.error) {
                showToast("error", res?.error?.data?.message);
            } else {
                if (res?.data?.status) {
                    showToast("success", res?.data?.message);
                    resetForm()
                    onClose();
                } else {
                    showToast("error", res?.data?.message);
                }
            }
            setSubmitting(false);
        });
    };

    return (
        <Dialog open maxWidth='xs' fullWidth>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formikProps) => (
                    <Form>
                        <BookForm formikProps={formikProps} onClose={onClose} formType='ADD' />
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default AddBookWrapper;